import React from "react";
import { Button, Drawer, Form, Input } from "antd";
import VehiclesTable from "../Drawer/SelectVehicles/SelectVehicles";

class Vehicle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      drawerSelectVehicle: false
    };
  }
  selectVehicle = rows => {
    this.props.form.setFieldsValue({
      vehicle:
        rows.vehicle.brand +
        " " +
        rows.vehicle.model +
        ", " +
        rows.registerSignAndRegion,
      vehicleId: rows.key
    });
    this.setState({ drawerSelectVehicle: false });
  };
  toggleVehicleDrawer = () => {
    this.setState(state => ({
      drawerSelectVehicle: !state.drawerSelectVehicle
    }));
  };
  render() {
    const { form, disabled } = this.props;
    const { getFieldDecorator, getFieldValue } = form;
    const isValue = getFieldValue("vehicle");
    return (
      <div className="offer-card__item">
        <span className="label">ТС:</span>
        <Form.Item className={isValue ? "visible-block" : "hidden-block"}>
          {getFieldDecorator("vehicle", {
            rules: [
              {
                required: true,
                message: "Поле, обязательное для заполнения"
              }
            ]
          })(<Input style={{ width: 368 }} disabled={true} />)}
        </Form.Item>
        <Form.Item hidden={true}>
          {getFieldDecorator("vehicleId", {
            rules: [
              {
                required: true,
                message: "Поле, обязательное для заполнения"
              }
            ]
          })(<Input style={{ width: 368 }} type="hidden" disabled={true} />)}
        </Form.Item>
        {disabled && !isValue ? (
          <Input
            style={{ width: 224 }}
            type="text"
            disabled={true}
            placeholder="не указано"
          />
        ) : (
          <Button
            style={{ minWidth: 176 }}
            type="primary"
            ghost
            disabled={disabled}
            onClick={this.toggleVehicleDrawer}
          >
            {isValue ? "Сменить ТС" : "Выбрать ТС"}
          </Button>
        )}
        <Drawer
          title="Выбор ТС"
          placement="left"
          closable={true}
          visible={this.state.drawerSelectVehicle}
          onClose={this.toggleVehicleDrawer}
          className="select-drawer"
          bodyStyle={{ height: "100%" }}
        >
          {
            <VehiclesTable
              selectVehicle={this.selectVehicle}
              serviceType={getFieldValue("serviceType")}
            />
          }
        </Drawer>
      </div>
    );
  }
}

export default Vehicle;
